import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * @param {"employee" | "admin"} accountType
 */
export default function LoginAccountType({ accountType }) {
  const navigate = useNavigate();
  const { t } = useTranslation("auth");

  const handleChange = (type) => {
    if (type === accountType) return;
    navigate(type === "admin" ? "/login/admin" : "/login");
  };

  return (
    <div className="login-page__account-type">
      <p className="login-page__account-type-label">{t("accountType")}</p>
      <div
        className="login-page__account-type-options"
        role="radiogroup"
        aria-label={t("accountType")}
      >
        <label className="login-page__account-type-option">
          <input
            type="radio"
            name="login-account-type"
            value="employee"
            checked={accountType === "employee"}
            onChange={() => handleChange("employee")}
          />
          <span>{t("accountTypeEmployee")}</span>
        </label>
        <label className="login-page__account-type-option">
          <input
            type="radio"
            name="login-account-type"
            value="admin"
            checked={accountType === "admin"}
            onChange={() => handleChange("admin")}
          />
          <span>{t("accountTypeAdmin")}</span>
        </label>
      </div>
    </div>
  );
}
